// Fonction pour convertir les nombres en lettres (version simplifiée)
const numberToWords = (num) => {
  if (num === 0) return 'zéro';
  
  const ones = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
  const tens = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante-dix', 'quatre-vingt', 'quatre-vingt-dix'];
  const thousands = ['', 'mille'];
  
  if (num < 10) return ones[num];
  if (num < 20) return 'dix';
  if (num < 100) {
    const ten = Math.floor(num / 10);
    const one = num % 10;
    return tens[ten] + (one ? ' ' + ones[one] : '');
  }
  if (num < 1000) {
    const hundred = Math.floor(num / 100);
    const rest = num % 100;
    return (hundred > 1 ? ones[hundred] + ' ' : '') + 'cent' + (rest ? ' ' + numberToWords(rest) : '');
  }
  if (num < 1000000) {
    const thousand = Math.floor(num / 1000);
    const rest = num % 1000;
    return (thousand === 1 ? 'mille' : numberToWords(thousand) + ' mille') + (rest ? ' ' + numberToWords(rest) : '');
  }
  
  return num.toString();
};

// Fonction pour convertir en chiffres arabes (simplifié)
const numberToArabicWords = (num) => {
  return num.toString(); // Pour l'instant, retourne le nombre en chiffres
};

module.exports = {
  numberToWords,
  numberToArabicWords
};
